import { makeRequest } from 'utils/requestLogger';

export default (roundtable_id, courseWorkID) =>
    makeRequest(
        'put',
        `/api/roundtables/${roundtable_id}/sync-course-work/${courseWorkID}`
    );



// WEBPACK FOOTER //
// ./src/app/features/onlineRoundtables/services/roundtable/syncCourseWork.js